import { Link, useLocation, useParams } from 'react-router-dom';
import { MENU_CATEGORIES } from '../../utils/constant';
import './index.css';

export default function SportCategoriesStrip() {
  const { categoryName } = useParams();
  const location = useLocation();

  const activeValue = (() => {
    if (categoryName) return categoryName.toLowerCase();
    const match = location.pathname.match(/^\/streams\/([^/]+)/i);
    return match ? decodeURIComponent(match[1]).toLowerCase() : null;
  })();

  const isHomeActive = !activeValue
    && (location.pathname === '/' || location.pathname === '/buffstream');

  return (
    <nav className="bs-sport-strip" aria-label="Sports categories">
      <Link
        className={`bs-sport-chip${isHomeActive ? ' bs-sport-chip-active' : ''}`}
        to="/"
        aria-current={isHomeActive ? 'page' : undefined}
      >
        Home
      </Link>
      {MENU_CATEGORIES.map((cat) => {
        const isActive = activeValue === cat.value.toLowerCase()
          || activeValue === cat.label.toLowerCase();
        return (
          <Link
            key={cat.value}
            className={`bs-sport-chip${isActive ? ' bs-sport-chip-active' : ''}`}
            to={`/streams/${cat.value}`}
            aria-current={isActive ? 'page' : undefined}
          >
            {cat.label}
          </Link>
        );
      })}
    </nav>
  );
}
